<template>
  <div>
    <slot />
    <nav-footer-info />
  </div>
</template>
